import { render } from "./LogoNdldc.vue?vue&type=template&id=7742b081&scoped=true&ts=true"
import script from "./LogoNdldc.vue?vue&type=script&lang=ts"
export * from "./LogoNdldc.vue?vue&type=script&lang=ts"

import "./LogoNdldc.vue?vue&type=style&index=0&id=7742b081&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7742b081"]])

export default __exports__